import CheckboxSwitcher from './common/checkbox-switcher.vue';
import Preloader from './common/preloader.vue';
import PreloaderBlock from './common/preloader-block.vue';
import Navbar from './common/navbar.component.vue';

export default {
    initializeComponents(Vue){
        Vue.component('checkbox-switcher', CheckboxSwitcher);
        Vue.component('preloader', Preloader);
        Vue.component('preloader-block', PreloaderBlock);
        Vue.component('navbar', Navbar);
    }
}


// WEBPACK FOOTER //
// ./src/components/index.js